import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import { toast, ToastContainer } from "react-toastify";
import axiosInsatnace, { chatStatus } from "../../asiosConfig";

import { ACTION_CONFIG } from "../../profileActions/actionConfig";
import { getProfileActionType } from "../../profileActions/actionResolver";
import { useProfileActions } from "../../profileActions/useProfileActions";

import {
  getMatchesByTypeJava,
  contactViewJava,
  profileActivityJava,
} from "../../javaAxiosConfig";

import CommonContactModal from "../UserComponent/Profile/CommonContactModal";

import "../UserComponent/MatchProfileContainer.css";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  ButtonBase,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  AddCircleSharp,
  Call,
  Chat,
  Check,
  Close,
  NotificationsActive,
  RemoveCircleSharp,
  Send,
  Star,
} from "@mui/icons-material";
import debounce from "lodash.debounce"; // Make sure to install lodash.debounce
import femaleImg from "../../images/female-default-profile.png";
import maleImg from "../../images/Male-default-profile.png";
import goldIcon from "../../images/gold.png";
import platinumIcon from "../../images/platinum.png";
import diamondIcon from "../../images/diamond.png";

import tillUMarryIcon from "../../images/assistedVip.png";
import { CircularLoader } from "../CircularLoader";
import educIcon from "../../images/educIcon.png";
import jobIcon from "../../images/jobIcon.png";
import heightIcon from "../../images/heightIcon.png";
import Profileicon from "../../images/view-photo-icon.svg";
import popup from "../../images/popup_design.png";
import TimeDateIcon from "../../images/TimeDateIcon.png";
import shortlistIcon from "../../images/shortlist-icon.svg";
import SendInterest from "../../images/intrest-icon.svg";
import IgnoreIcon from "../../images/ignore-icon.svg";
import ContactIcon from "../../images/contact-icon.svg";
import AcceptInterestIcon from "../../images/AcceptInterestIcon.png";
import BookMarkRemoveIcon from "../../images/bookmark-icon.svg";

import BlueVerified from "../../images/BlueVerified.png";

import premiumPlusIcon from "../../images/crownIconPremium.svg";
// import assistedVip from "../../../images/assistedVip.png";

import { IoMdUndo } from "react-icons/io";

import BookmarkIcon from "../../images/bookmark-icon.svg";
import BookmarkIconFilled from "../../images/bookmarkIconFilled.svg";

import DeclinedInterestIcon from "../../images/DelinedIcon.png";
import sendRemidIcon from "../../images/sendReminder.png";

import ChatIcon from "../../images/messageNow.svg";
import RemoveIgnoreIcon from "../../images/RemoveIgnoreIcon.png";
import { useTheme } from "@mui/material/styles";
import { handleStartChat } from "./handleStartChat";
import { collection } from "firebase/firestore";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../services/firebaseConfig";
import MessengerModal from "../MessengerModel";

const formatTitle = (title) => {
  return title
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};

const useSafeImage = (src, fallback) => {
  const [imgSrc, setImgSrc] = useState(fallback);

  useEffect(() => {
    if (!src) return;

    const img = new Image();
    img.src = src;

    img.onload = () => setImgSrc(src);
    img.onerror = () => setImgSrc(fallback);
  }, [src, fallback]);

  return imgSrc;
};

// fallback-safe profile image
const getProfileImage = (item, defaultImage) => {
  if (item?.photo && item.photo !== "null") return item.photo;
  return defaultImage;
};

// last seen / online text (UI only)
const getLastSeen = (item) => {
  if (item?.last_login && item.last_login.trim() !== "") {
    return item.last_login;
  }
  return null;
};

// Build profile detail pills (UI only, data-safe)
const getDetails = (item) => {
  const details = [];

  if (item?.age) details.push(`${item.age} yr`);
  if (item?.height) details.push(item.height);
  if (item?.maritalStatus) details.push(item.maritalStatus);
  if (item?.city) details.push(item.city);
  if (item?.education) details.push(item.education);
  if (item?.occupation) details.push(item.occupation);
  if (item?.income) details.push(item.income);

  return details;
};

const packageIcons = {
  Gold: goldIcon,
  Platinum: platinumIcon,
  Diamond: diamondIcon,
  Premium: premiumPlusIcon,
  "Premium+": premiumPlusIcon,
  Assisted: tillUMarryIcon,
};

const MatchCard = ({
  item,
  defaultImage,
  lastMatchElementRef,
  isLast,
  handleSearch,

  handleViewPhoto,

  bookmarkAnimating,
  handleToggleBookmark,
  getActionButton,
}) => {
  const safePhoto = useSafeImage(
    getProfileImage(item, defaultImage),
    defaultImage,
  );

  const hasRow1 =
  item.occupation ||
  item.income ||
  item.residingCity;

const hasRow2 =
  item.age ||
  item.height ||
  item.maritalStatus;

const hasRow3 =
  item.caste ||
  item.religion;

const hasRow4 =
  item.education ||
  item.nativeCity ||
  item.nativeState;

  return (
    <div key={item.id} ref={isLast ? lastMatchElementRef : null}>
      <div className="match-card-container mt-3">
        <div
          className="match-card-image-wrapper"
          // onClick={() => handleSearch(item.username, item.last_viewed)}
        >
          {/* BLURRED BACKGROUND */}
          <div
            className="match-card-bg-fill"
            style={{ backgroundImage: `url("${safePhoto}")` }}
            onClick={() => handleSearch(item.username, item.last_viewed)}
          />
          {/* MAIN IMAGE */}
          <div
            className="match-card-main-bg"
            style={{ backgroundImage: `url("${safePhoto}")` }}
            onClick={() => handleSearch(item.username, item.last_viewed)}
          />

          {/* 🔹 VIEW PHOTO ICON */}

          {item.photoCount > 1 && (
            <div
              className="view-photo-btn"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleViewPhoto(item);
              }}
            >
              <img src={Profileicon} alt="View Photos" />
              <span className="photo-count">{item.photoCount}</span>
            </div>
          )}

          {/* 🔹 PREMIUM BADGE */}
          {item.membership_type !== "Free" && (
            <div
              className={`premium-badge premium-${item.membership_type.toLowerCase()}`}
            >
              <img
                style={{ width: "20px", height: "20px" }}
                src={
                  item.membership_type === "Premium+"
                    ? premiumPlusIcon
                    : item.membership_type === "Premium"
                      ? premiumPlusIcon
                      : item.membership_type === "Assisted"
                        ? tillUMarryIcon
                        : null
                }
                alt={item.membership_type}
              />
              <span
                style={{ marginLeft: "2px", fontSize: "11px", fontWeight: 600 }}
              >
                {item.membership_type}
              </span>
            </div>
          )}

          {/* ONLINE / LAST SEEN */}
          {item.last_login && (
            <>
              <div
                className={`online-dot ${
                  item.last_login === "Online"
                    ? "online"
                    : "online-dot--offline"
                }`}
              />
              <div
                className={`online-status-badge ${
                  item.last_login === "Online"
                    ? "online"
                    : "online-status-badge--offline"
                }`}
              >
                {item.last_login === "Online"
                  ? "Online Available"
                  : `Last seen ${item.last_login}`}
              </div>
            </>
          )}
        </div>

        <div
          className="match-card-content"
          onClick={() => handleSearch(item.username, item.last_viewed)}
        >
          <div className="match-card-content-inner">
            <div className="match-card-top">
             

                {/* USERNAME ABOVE NAME */}
                {item.username && (
                  <div className="match-card-username">
                    ID - {item.username}
                  </div>
                )}

                {/* NAME + VERIFIED */}
                <div className="match-card-name-row">
                  <div className="match-card-name">
                    {item.name}
                    {item.verifiedStatus === true && (
                      <img
                        src={BlueVerified}
                        alt="Verified"
                        className="verified-icon"
                      />
                    )}
                  </div>

                  <div
                    className={`bookmark-btn ${
                      bookmarkAnimating === item.id ? "animate" : ""
                    }`}
                    onClick={(e) => handleToggleBookmark(item, e)}
                  >
                    <img
                      src={item.bookmarked ? BookmarkIconFilled : BookmarkIcon}
                      alt="Bookmark"
                      className="bookmark-svg"
                    />
                  </div>
                </div>

                {/* ROW 1 */}

                {hasRow1 && (
                <div className="match-card-details-grid">
                  {item.occupation && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.occupation}</span>
                    </div>
                  )}
                  {item.income && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.income}</span>
                    </div>
                  )}
                  {item.residingCity && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.residingCity}</span>
                    </div>
                  )}
                </div>
                )}

                {/* ROW 2 */}
                {hasRow2 && (
                <div className="match-card-details-grid">
                  {item.age && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.age} Years</span>
                    </div>
                  )}
                  {item.height && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.height}</span>
                    </div>
                  )}
                  {item.maritalStatus && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">
                        {item.maritalStatus}
                      </span>
                    </div>
                  )}
                </div>
                )}

                {/* ROW 3 */}
                {hasRow3 && (
                <div className="match-card-details-grid">
                  {item.caste && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.caste}</span>
                    </div>
                  )}
                  {item.religion && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.religion}</span>
                    </div>
                  )}
                </div>
                )}

                {/* ROW 4 */}
                {hasRow4 && (
                <div className="match-card-details-grid">
                  {item.education && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.education}</span>
                    </div>
                  )}
                  {item.nativeCity && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.nativeCity}</span>
                    </div>
                  )}
                  {item.nativeState && (
                    <div className="match-card-detail-item">
                      <span className="gradient-text">{item.nativeState}</span>
                    </div>
                  )}
                </div>
                )}
              
            </div>

            <div className="match-card-bottom">
              <div className="match-card-divider" />
              {getActionButton(item)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function MatchProfileContainer({ matchesType: propMatchesType, filters }) {
  const { matchesType: paramMatchesType } = useParams();
  // console.log('MatchProfileContainer paramMatchesType:', paramMatchesType);

  const matchesType = propMatchesType || paramMatchesType || "my_matches";
  // console.log('MatchProfileContainer matchesType:', matchesType);
  const title = paramMatchesType ? formatTitle(paramMatchesType) : "My Matches";

  const payloadKey = JSON.stringify({
    matchesType,
    filters,
  });

  const storageKey = `MATCH_RESTORE_${btoa(
    unescape(encodeURIComponent(payloadKey)),
  )}`;

  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const { handleAction, handleIgnore, isActionLoading } = useProfileActions({
    setProfiles: setMatches,
  });

  // console.log("[MATCH ROUTE DEBUG]", {
  //   url: window.location.pathname,
  //   paramMatchesType,
  //   propMatchesType,
  // });

  const [contactInfo, setContactInfo] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const navigate = useNavigate();
  const observer = useRef();

  const lastMatchElementRef = useRef(null);

  const [isHydrated, setIsHydrated] = useState(false);

  const restoredOnceRef = useRef(false);
  const skipNextFetchRef = useRef(false);
  const inFlightPagesRef = useRef(new Set());

  const removeDuplicates = (list) => {
    const seen = new Set();
    return list.filter((item) => {
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
  };

  // const token = localStorage.getItem('token');
  const gender = localStorage.getItem("gender");
  const [openReminderPopup, setOpenReminderPopup] = useState(false);
  const [reminderData, setReminderData] = useState(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const username = localStorage.getItem("username");

  const [openMessengerModal, setOpenMessengerModal] = useState(false);

  const [bookmarkAnimating, setBookmarkAnimating] = useState(null);

  const [interestAnimating, setInterestAnimating] = useState(null);

  // Debounce function to limit API calls
  const fetchMatches = useCallback(
    async (currentPage, currentFilters, currentMatchType) => {
      setLoading(true);
      try {
        const response = await getMatchesByTypeJava({
          type: currentMatchType,
          page: currentPage,
          limit: 5,
        });

        if (response.status === 200 || response.status === 201) {
          const rawProfiles = Array.isArray(response.data?.profiles)
            ? response.data.profiles
            : [];

          // debuging the match response data
          // console.log("JAVA MATCHES RESPONSE", response.data);

          const normalizedProfiles = rawProfiles.map((p) => ({
            ...p,

            // photo: p.profilePhoto ? encodeURI(p.profilePhoto) : "",

            photo: p.profilePhoto || "",

            name: p.name || "",

            last_login: p.lastSeen?.trim() ? p.lastSeen : null,
            last_viewed: p.date_viewed || null,

            city:
              p.nativeCity && p.nativeState
                ? `${p.nativeCity}, ${p.nativeState}`
                : p.nativeCity || p.nativeState || null,

            membership_type: p.membershipType || "Free",

            // 🔑 unified flags
            interestAccepted: p.interest_i_accept === true,
            interestReceived: p.interestReceived === true,
            interestSent: p.interestSent === true,

            isIgnored: p.isIgnored === true,
            ignored: p.isIgnored ? { member_id: p.id } : null,

            bookmarked: p.isShortlisted,

            caste: p.caste || null,
            religion: p.religion || null,
            nativeCity: p.nativeCity || null,
            nativeState: p.nativeState || null,
            verifiedStatus: p.verifiedStatus === true,
          }));

          if (normalizedProfiles.length === 0) {
            setHasMore(false); // 🚨 STOP HERE
            return;
          }

          // setMatches((prev) => [...prev, ...normalizedProfiles]);

          setMatches((prev) =>
            removeDuplicates([...prev, ...normalizedProfiles]),
          );

          // safer hasMore logic
          const totalFetched =
            (currentPage - 1) * 5 + normalizedProfiles.length;
          setHasMore(totalFetched < response.data.pagination?.total);
        }
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
        setDataLoaded(true);
      }
    },
    [],
  );

  useLayoutEffect(() => {
    const raw = sessionStorage.getItem(storageKey);

    if (!raw) {
      setIsHydrated(true);
      return;
    }

    try {
      const saved = JSON.parse(raw);

      restoredOnceRef.current = true;
      skipNextFetchRef.current = true;

      setMatches(saved.matches || []);
      setPage(saved.page || 1);
      setHasMore(saved.hasMore ?? true);
      setDataLoaded(true);

      window.scrollTo(0, saved.scrollY || 0);

      sessionStorage.removeItem(storageKey);
    } catch (e) {
      sessionStorage.removeItem(storageKey);
    }

    setIsHydrated(true);
  }, [storageKey]);

  // Trigger fetch when matchesType or filters change
  useEffect(() => {
    if (restoredOnceRef.current) return;

    setMatches([]);
    setPage(1);
    setHasMore(true);
    setDataLoaded(false);

    fetchMatches(1, filters, matchesType);
  }, [matchesType, filters]);

  // Handle page changes for infinite scrolling

  useEffect(() => {
    if (!hasMore) return;
    if (loading) return;
    if (page === 1) return;

    fetchMatches(page, filters, matchesType);
  }, [page]);

  useEffect(() => {
    if (loading || !hasMore) {
      if (observer.current) observer.current.disconnect();
      return;
    }

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading && hasMore) {
        setPage((prev) => prev + 1);
      }
    });

    if (lastMatchElementRef.current) {
      observer.current.observe(lastMatchElementRef.current);
    }

    return () => observer.current?.disconnect();
  }, [loading, hasMore]);

  const defaultImage = gender === "F" ? maleImg : femaleImg;

  // const handleSearch = (username, lastViewed) => {
  //   console.log("➡️ Navigating to profile", {
  //     username,
  //     lastViewed,
  //   });

  //   navigate(`/profile-view/${username}`, {
  //     state: { last_viewed: lastViewed || null },
  //   });
  // };

  const handleSearch = (username, lastViewed) => {
    const toSave = {
      matches,
      page,
      hasMore,
      scrollY: window.scrollY,
      savedAt: Date.now(),
    };

    sessionStorage.setItem(storageKey, JSON.stringify(toSave));

    navigate(`/profile-view/${username}`, {
      state: { last_viewed: lastViewed || null },
    });
  };

  const handleToggleBookmark = async (profile, e) => {
    e.stopPropagation();

    const isBookmarked = profile.bookmarked;

    // animation trigger
    setBookmarkAnimating(profile.id);

    // optimistic UI update
    setMatches((prev) =>
      prev.map((p) =>
        p.id === profile.id ? { ...p, bookmarked: !isBookmarked } : p,
      ),
    );

    try {
      await profileActivityJava({
        user_id: profile.id,
        response_type: isBookmarked ? "remove_bookmark" : "bookmark",
      });
    } catch (err) {
      // rollback on failure
      setMatches((prev) =>
        prev.map((p) =>
          p.id === profile.id ? { ...p, bookmarked: isBookmarked } : p,
        ),
      );
      toast.error("Unable to update shortlist");
    } finally {
      setTimeout(() => setBookmarkAnimating(null), 300);
    }
  };

  const handleReminder = async (url, data, label) => {
    // set loading state to the current action label
    try {
      const response = await profileActivityJava(data);
      if (response.status === 200 || response.status === 201) {
        logEvent(analytics, "sendReminder", {
          user_id: localStorage.getItem("user"),
          profile_id: data.user_id,
          action: data.response_type,
          platform: "web",
          timestamp: new Date().toISOString(),
        });
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setLoading(null); // reset loading state after response
    }
  };
  const handleSendReminder = async () => {
    if (!reminderData) return;
    setLoading("Send Reminder");
    try {
      const response = await axiosInsatnace.post(
        reminderData.url,
        reminderData.data,
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message);
        setOpenReminderPopup(false); // Close the popup after success
      } else {
        setOpenReminderPopup(false);
        toast.error(response.data.message);
      }
    } catch (error) {
      setOpenReminderPopup(false);
      toast.error(error.response?.data?.message || "Failed to send reminder");
    } finally {
      setLoading(null);
    }
  };

  const handleContactClick = async (profile) => {
    setLoading("Contact");

    try {
      const response = await contactViewJava({
        toUserId: profile.id, // ✅ correct payload
      });

      const { status, message, errorCode } = response.data;

      if (status === true) {
        // ✅ success → mobile number
        setContactInfo({
          type: "success",
          message, // mobile number comes here
          phone: message,
          username: profile.username,
          photo: profile.photo,
          errorCode: null,
        });
      } else {
        // ✅ failure → API message
        setContactInfo({
          type: "error",
          phone: null,
          message,
          username: profile.username,
          photo: profile.photo,
          errorCode: errorCode || null,
        });
      }

      setOpenModal(true); // ✅ ALWAYS open modal
    } catch (error) {
      setContactInfo({
        type: "error",
        phone: null,

        message:
          error.response?.data?.message ||
          "Unable to fetch contact details at the moment.",
        username: profile?.username,
        photo: profile?.photo,
        errorCode: error.response?.data?.errorCode || null,
      });

      setOpenModal(true); // ✅ open modal even on error
    } finally {
      setLoading(null);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const startChat = async (recipientId, profile) => {
    setOpenMessengerModal(true);
  };

  const handleViewPhoto = async (profile) => {
    try {
      await profileActivityJava({
        user_id: profile.id,
        response_type: "view_photo",
      });

      // ✅ SAME FLOW AS PROFILE VIEW
      navigate(`/view-user-photos/${profile.id}`);
    } catch (err) {
      toast.error("Unable to load photos");
    }
  };

  const getActionButton = (profile) => {
    const actionType = getProfileActionType(profile);
    const actions = ACTION_CONFIG[actionType] || [];

    return (
      <Box
        display="flex"
        className="action-container"
        justifyContent="space-between"
      >
        {actions.map((action) => {
          switch (action) {
            case "SEND_INTEREST":
              return (
                <div
                  key={action}
                  className={`figma-btn send-intrest-btn
        ${interestAnimating === profile.id ? "interest-pulse interest-slide" : ""}
      `}
                  onClick={(e) => {
                    e.stopPropagation();

                    handleAction(
                      { user_id: profile.id, response_type: "interest" },
                      "SEND_INTEREST",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div
                    className={`figma-btn-content send-intrest
          ${interestAnimating === profile.id ? "interest-slide-text" : ""}
        `}
                  >
                    <span>Send Interest</span>
                    <img src={SendInterest} className="figma-btn-icon" />
                  </div>
                </div>
              );

            case "SEND_REMINDER":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAction(
                      { user_id: profile.id, response_type: "send_reminder" },
                      "Send Reminder",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Reminder</span>
                    <img src={sendRemidIcon} className="figma-btn-icon" />
                  </div>
                </div>
              );

            case "ACCEPT":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    if (isActionLoading(profile.id, "Accept")) return;
                    e.stopPropagation();
                    handleAction(
                      { user_id: profile.id, response_type: "accept" },
                      "ACCEPT",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Accept</span>
                    <img src={AcceptInterestIcon} className="figma-btn-icon" />
                  </div>
                </div>
              );

            case "DECLINE":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    if (isActionLoading(profile.id, "Decline")) return;
                    e.stopPropagation();
                    // handleAction(
                    //   { user_id: profile.id, response_type: "reject" },
                    //   "Decline",
                    //   profile.id,
                    // );

                    handleAction(
                      { user_id: profile.id, response_type: "reject" },
                      "DECLINE",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Decline</span>
                    <img
                      src={DeclinedInterestIcon}
                      className="figma-btn-icon"
                    />
                  </div>
                </div>
              );

            case "CHAT":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    startChat(profile.username, profile);
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Chat</span>
                    <img src={ChatIcon} className="figma-btn-icon" />
                  </div>
                </div>
              );

            case "CONTACT":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleContactClick(profile);
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Contact</span>
                    <img src={ContactIcon} className="figma-btn-icon" />
                  </div>
                </div>
              );

            case "IGNORE":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleIgnore(profile);
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    {isActionLoading(profile.id, "IGNORE") ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <span>Ignore</span>
                        <img src={IgnoreIcon} className="figma-btn-icon" />
                      </>
                    )}
                  </div>
                </div>
              );

            case "REMOVE_IGNORE":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();

                    handleAction(
                      { user_id: profile.id, response_type: "remove_ignore" },
                      "REMOVE_IGNORE",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Remove Ignore</span>
                    {/* <img 
                    src={RemoveIgnoreIcon} 
                    className="figma-btn-icon" /> */}

                    <IoMdUndo className="figma-btn-icon" />
                  </div>
                </div>
              );

            default:
              return null;
          }
        })}
      </Box>
    );
  };

  // const isActionLoading = (profileId, action) => actionLoading.profileId === profileId && actionLoading.action === action;

  const handleClosePopup = () => {
    setOpenReminderPopup(false);
    setReminderData(null);
  };

  if (!isHydrated) {
    return null;
  }

  return (
    <div className="col-lg-9 col-12">
      {dataLoaded && matches.length === 0 ? (
        <p>No Data Available</p>
      ) : (
        matches.map((item, index) => (
          <MatchCard
            key={item.id}
            item={item}
            defaultImage={defaultImage}
            lastMatchElementRef={lastMatchElementRef}
            isLast={index === matches.length - 1}
            handleSearch={handleSearch}
            bookmarkAnimating={bookmarkAnimating}
            handleToggleBookmark={handleToggleBookmark}
            getActionButton={getActionButton}
            handleViewPhoto={handleViewPhoto}
          />
        ))
      )}

      {loading && <CircularProgress />}

      <CommonContactModal
        open={openModal}
        onClose={handleCloseModal}
        profileData={{
          photo: contactInfo?.photo,
          fallbackPhoto: defaultImage,
          user_info: { register_id: contactInfo?.username },
          phone: contactInfo?.phone, // ✅ phone only
          type: contactInfo?.type,
          message: contactInfo?.message, // ✅ error text only
          errorCode: contactInfo?.errorCode,
        }}
      />

      <ToastContainer />

      {/* Reminder popup */}
      <Dialog
        open={openReminderPopup}
        onClose={handleClosePopup}
        aria-labelledby="reminder-dialog-title"
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            backgroundImage: `url('${popup}')`, // Replace with your image URL
            backgroundSize: "cover", // Ensures the image covers the entire background
            backgroundRepeat: "no-repeat", // Prevents tiling
            backgroundPosition: "center", // Centers the image
          },
        }}
      >
        <DialogTitle id="reminder-dialog-title" align="center">
          <Typography variant="h6">Interest Already Sent</Typography>
          <Divider variant="middle" sx={{ mb: 2 }} />
          <IconButton
            aria-label="close"
            onClick={handleClosePopup}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
          >
            <Typography variant="body1" gutterBottom>
              You have already sent an interest to this user. Would you like to
              send a reminder?
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 3,
                background: "linear-gradient(90deg, #B60202 0%, #500101 100%)",
                color: "white",
                borderRadius: 3,
                padding: "10px 20px",
              }}
              disabled={loading === "Send Reminder"}
              onClick={handleSendReminder}
            >
              {loading === "Send Reminder" ? "Sending..." : "Send Reminder"}
              {/* <Star sx={{ ml: 1, color: "white", fontSize: "20px" }} /> */}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <MessengerModal
        open={openMessengerModal}
        onClose={() => setOpenMessengerModal(false)}
      />
    </div>
  );
}

export default MatchProfileContainer;
